import { useCallback, useReducer, useEffect, useRef } from 'react';

const useDeferredFocus = () => {
  const [focusCount, deferredFocus] = useReducer(x => x + 1, 0);

  const nodeRef = useRef();

  const inputRefCb = useCallback(node => {
    if (node) {
      nodeRef.current = node;
      deferredFocus();
    }
  }, []);

  useEffect(() => {
    if (focusCount && nodeRef.current) {
      nodeRef.current.focus();
    }
  }, [focusCount]);

  return inputRefCb;
};

export default useDeferredFocus;
